import React from 'react';

import { TableHead, TableCell, TableRow, Typography, TableSortLabel, LinearProgress } from '@material-ui/core';
import { TiArrowUnsorted } from 'react-icons/ti';

const TableHeader = (props) => {
  const { columns, order, orderBy, onRequestSort, isLoading } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {
          columns.map((column, index) => (
            <TableCell key={index}>
              <TableSortLabel
                IconComponent={TiArrowUnsorted}
                hideSortIcon={column.noSorting}
                active={!column.noSorting}
                direction={orderBy === column.accessor ? order : 'asc'}
                onClick={createSortHandler(column.accessor)}
              >
                <Typography
                  style={{fontSize: 12}}
                  color="textSecondary"
                >
                  {column.Header ? column.Header.toUpperCase() : ''}
                </Typography>
              </TableSortLabel>

            </TableCell>
          ))
        }
      </TableRow>
      <TableRow>
        <TableCell height="4px" colSpan="100%" style={{ padding: 0, borderBottom: 'none'}}>
          { isLoading && <LinearProgress /> }
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;